import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEnvironmentStore = defineStore('environment', () => {
  const environmentName = ref<string>('');
  const configCache = ref<Record<string, unknown>>({});

  function setEnvironmentName (name: string) {
    environmentName.value = name;
  }
  function setConfigCache (cache: Record<string, unknown>) {
    configCache.value = cache;
  }

  return {
    environmentName,
    configCache,
    setEnvironmentName,
    setConfigCache,
  };
});
